import { StarRating, Icon, Text } from '@lounge-fe/ui-kit'
import { DetailsProps } from './types'
import { t } from 'i18next'

const Details = ({ rating, title, verified }: DetailsProps) => {
  return (
    <div className="grid grid-cols-[1fr_max-content] gap-1">
      <StarRating stars={rating} maxStars={5} />
      {verified && (
        <div className="inline-flex items-center border gap-2 px-2 py-1 rounded-circle">
          <i className="h-4 w-4 bg-action-primary-default text-inverse rounded-circle items-center justify-center flex">
            <Icon.Check className="h-2 w-2" />
          </i>
          <Text variant="body-sm" className="font-regular">
            {t('general.verified')}
          </Text>
        </div>
      )}
      <Text variant="title-six" className="font-regular text-sm" as="h5">
        {title}
      </Text>
    </div>
  )
}

export default Details
